import { useEffect, useState } from 'react';

import type {
  ContributionInfo,
  ContributionInfoResponseDto,
} from '@/api/campaign/grass/grass.dto';

import { copyCurrentUrl } from '../../logic';

export const shareInstagram = () => {
  const instagramUrl = 'instagram://';
  const webUrl = 'https://www.instagram.com/';
  const appStoreUrl = 'https://apps.apple.com/kr/app/instagram/id389801252';
  const playStoreUrl =
    'https://play.google.com/store/apps/details?id=com.instagram.android';

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

  if (isMobile) {
    const tryOpenApp = () => {
      const now = Date.now();

      setTimeout(() => {
        if (Date.now() - now < 2100) {
          window.location.href = isIOS ? appStoreUrl : playStoreUrl;
        }
      }, 1000);

      window.location.href = instagramUrl;
    };

    tryOpenApp();
  } else {
    window.open(webUrl, '_blank');
  }
};

export const shareKakao = (currentUrl: string, name: string) => {
  const { Kakao } = window;
  Kakao.Share.sendScrap({
    requestUrl: currentUrl,
    templateId: 115219,
    templateArgs: { url: currentUrl, name: name },
  });
};

const useCurrentUrl = () => {
  const [currentUrl, setCurrentUrl] = useState('');

  useEffect(() => {
    setCurrentUrl(window.document.location.href);
  }, []);

  return currentUrl;
};

const formatTopThreeContributors = (
  topThreeContributionInfos: ContributionInfo[] | undefined,
): ContributionInfo[] | undefined => {
  return topThreeContributionInfos?.map((info) => {
    const [username, ...rest] = info.gitHubUsername.split('외');
    const restString = rest.length > 0 ? ` 외${rest.join('외')}` : '';

    return {
      ...info,
      gitHubUsername: `${username.trim()} 님${restString}`,
    };
  });
};

export const useKeepCommitLogic = (
  contributionData: ContributionInfoResponseDto,
) => {
  const currentUrl = useCurrentUrl();

  const handleClickContentCopy = () => {
    copyCurrentUrl();
  };

  const parseTopThreeContributionData = formatTopThreeContributors(
    contributionData?.topThreeContributionInfos,
  );

  return {
    currentUrl,
    handleClickContentCopy,
    parseTopThreeContributionData,
  };
};
